/**
 * Brand-pack nav overlays name their icon with one of the server's ALLOWED_NAV_ICONS
 * (src/_config/brand-config.types.ts, Lucide names, shared with the legacy UI). The
 * new UI draws Radix icons, so the names map here and the server contract stays as it
 * is. A root tooling test fails if the server adds a name this table doesn't map.
 */
import {
  ArchiveIcon,
  BarChartIcon,
  BookmarkIcon,
  ClipboardIcon,
  CubeIcon,
  DashboardIcon,
  DesktopIcon,
  EyeOpenIcon,
  FileTextIcon,
  GearIcon,
  GlobeIcon,
  GridIcon,
  HamburgerMenuIcon,
  HomeIcon,
  LayersIcon,
  LockClosedIcon,
  MagicWandIcon,
  MagnifyingGlassIcon,
  MixerHorizontalIcon,
  PersonIcon,
  QuestionMarkCircledIcon,
  ReloadIcon,
  ShuffleIcon,
  StackIcon,
  StarFilledIcon,
  StarIcon,
  TokensIcon,
} from '@radix-ui/react-icons';
import type { IconProps } from '@radix-ui/react-icons/dist/types';
import type { ComponentType } from 'react';

export type NavIcon = ComponentType<IconProps>;

export const OVERLAY_ICONS: Record<string, NavIcon> = {
  BarChart3: BarChartIcon,
  Gamepad: CubeIcon,
  Users: PersonIcon,
  Airplay: DesktopIcon,
  Dices: ShuffleIcon,
  PiggyBank: TokensIcon,
  ShieldUser: LockClosedIcon,
  User: PersonIcon,
  Gift: StarIcon,
  Search: MagnifyingGlassIcon,
  RefreshCw: ReloadIcon,
  BookmarkCheck: BookmarkIcon,
  SlidersHorizontal: MixerHorizontalIcon,
  LifeBuoy: QuestionMarkCircledIcon,
  LayoutDashboard: DashboardIcon,
  Settings: GearIcon,
  Building2: GlobeIcon,
  Coins: TokensIcon,
  Trophy: StarFilledIcon,
  ClipboardList: ClipboardIcon,
  Wrench: GearIcon,
  Database: StackIcon,
  Home: HomeIcon,
  Menu: HamburgerMenuIcon,
  Grid3x3: GridIcon,
  Layers: LayersIcon,
  Package: ArchiveIcon,
  CircleDollarSign: TokensIcon,
  Sparkles: MagicWandIcon,
  Eye: EyeOpenIcon,
  FileText: FileTextIcon,
  Server: StackIcon,
};
